import { Observable } from 'rxjs/Observable';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent ,HttpXsrfTokenExtractor} from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class XsrfInterceptor implements HttpInterceptor {
  constructor(private tokenExtractor: HttpXsrfTokenExtractor) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = request.clone({
      withCredentials: true,
      setHeaders: {
        'Content-Type' : 'application/json; charset=utf-8',
        'Accept'       : 'application/json',
      }

     });
     let cookieheaderName = "RequestVerificationToken"
     let csrfToken = this.tokenExtractor.getToken() as string;
     if (csrfToken !== null && !request.headers.has(cookieheaderName)) {
       request = request.clone({ headers: request.headers.set(cookieheaderName, csrfToken) });
     }
    return next.handle(request);
  }
}
